import { useState } from 'react'
import { Button, Form, Label, Input, Alert, Modal, ModalHeader, ModalBody, Row, Col, ModalFooter } from 'reactstrap'
import { gql } from '@apollo/client'
import { useMutation } from '@apollo/client/react'
import { deepCopy, handleGraphQLErrors } from '../../utils'
import { AUTHORIZE_MUTATION } from '../../graphql.js'
import MethodButton from './MethodButton'
import './Login.css'

const AUTHORIZE =  gql(AUTHORIZE_MUTATION)

export default function MFA(props) {
  console.log('MFA rendered: ', props)
  let {handleLogin, loginData, modal, toggle, setMfaComponent} = props

  const [mfaMutation] = useMutation(AUTHORIZE)
  const [localLoginData, setLocalLoginData] = useState(loginData)
  const [mfaError, setmfaError] = useState()
  const [mfaInput, setmfaInput] = useState({mfaCode: '', saveDevice: 'N', userId: localLoginData.id})
  const expireMinutes = localLoginData.mfaCodeExpireMinutes
  const messageType = localLoginData.mfaMethod === 'SMS' && localLoginData.cellPhone ? 'A text message' : 'An email'
  const address = localLoginData.mfaMethod === 'SMS' && localLoginData.cellPhone ? localLoginData.cellPhone : localLoginData.email

  function handleMfaInputChange(event, checkbox) {
    const newMfa = deepCopy(mfaInput)
    if (checkbox) {
      newMfa[event.target.name] = event.target.checked ? 'Y' : 'N'
    } else {
      newMfa[event.target.name] = event.target.value
    }
    setmfaInput(newMfa)
    return true
  }

  function handleKeyDown(event) {
    if (event.key === 'Enter') {
      event.preventDefault()
      submitMFA()
    }
  }

  async function submitMFA() {
    console.log('Method: ', localLoginData.mfaMethod)
    try {
      await mfaMutation({ variables: { userId: mfaInput.userId, mfaCode: mfaInput.mfaCode, saveDevice: mfaInput.saveDevice, method: localLoginData.mfaMethod } })
        .then((res) => {
          console.log('Login.submitMFA:', res)
          if (res.data.authorize === 'SUCCESS') {
            handleLogin()
          }
        })
    } catch (err) {
      handleGraphQLErrors(err, setmfaError)
    }
  }

  let errorAlert = mfaError ? <Alert color="danger">{mfaError[0].message}</Alert> : ''
  function closeModal() {
    toggle()
    setMfaComponent(null)
  }

  let alternateMethodButton = <MethodButton loginData={localLoginData} setLoginData={setLocalLoginData} />

  if (localLoginData.mfaMethod === 'SMS' && !localLoginData.cellPhone) {
    errorAlert = <Alert color="warning">Your multi-factor authentication (MFA) method is currently set to "SMS" but no cell phone number is specified in your user profile. The MFA method will default to "Email".</Alert>
    alternateMethodButton = ''
  }

  let message = `${messageType} containing an authorization code has been sent to ${address}.  The code will expire in ${expireMinutes} minutes.`
  if (localLoginData.mfaMethod === 'APP') {
    if (localLoginData.hasSecret) {
      message = 'Use the authenticator app on your phone to obtain an access code.'
    } else {
      errorAlert = <Alert color="warning">Your multi-factor authentication (MFA) method is currently set to "Authenticator Application" but no QR code has been verified. The MFA method will default to "Email".</Alert>
    }
  }

  return (
    <Modal isOpen={modal} backdrop='static' toggle={closeModal}>
      <ModalHeader>Multi-Factor Authentication Required</ModalHeader>
      <ModalBody>
        <Form>
          {errorAlert}
          <Row>
            <Col>
              <p style={{ fontWeight: 'bold', textAlign: 'left' }}>This device was not recognized.</p>
              <p style={{ textAlign: 'left' }}>{message}</p>
            </Col>
          </Row>
          <Row>
            <Col>
              <Label for="mfaCode" style={{ float: 'left'}}>Enter Code</Label>
              <Input name="mfaCode" id="mfaCode" onChange={handleMfaInputChange} onKeyDown={handleKeyDown} />
            </Col>
          </Row>
          <Row>
            <Col style={{ textAlign: 'left', paddingTop: '10px' }}>
              <Input type="checkbox" name="saveDevice" onChange={(event) => handleMfaInputChange(event, true)} onKeyDown={handleKeyDown} />
              <Label style={{ paddingLeft: '5px'}}>Remember this device for future logins</Label>
            </Col>
          </Row>
          <Row>
            <Col style={{ textAlign: 'left', paddingTop: '10px' }}>
              {alternateMethodButton}
            </Col>
          </Row>
        </Form>
      </ModalBody>
      <ModalFooter>
        <Button color="secondary" onClick={closeModal} >Cancel</Button>
        <Button color="primary" onClick={submitMFA}>Submit</Button>
      </ModalFooter>
    </Modal>
  )
}